import detailApiCall from './detail';
import editApiCall from './edit';
import createApiCall from './create';

const ApiCall = {
  list: null,
  detail: detailApiCall,
  create: createApiCall,
  edit: editApiCall,
  delete: null,
};

export default ApiCall;
